import React, { useMemo, useState, useEffect } from "react";
import {Typography, Divider, TextField, MenuItem, Grid, Paper, Checkbox, FormControlLabel, Box, IconButton} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SubjectOutlinedIcon from "@material-ui/icons/SubjectOutlined";
import NotesOutlinedIcon from "@material-ui/icons/NotesOutlined";
import SectionListMentora from "../ui/SectionListMentora";
import NavActionsMentora from "../ui/NavActionsMentora";
import { InfoBasicaAsignaturaCard } from "../SisefTables";
import TareasTerminadas from "../../../general/TareasTerminadas";
import emma_s1 from "./../../../../global/imagenes/emma_s1.png";
import PlaneadorActions from "../ui/PlaneadorActions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";

export function PlaneadorShell({ children }) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={11} lg={10} xl={9} style={{ padding: "0 16px" }}>
        {children}
      </Grid>
    </Grid>
  );
}

export function PlaneadorTopBar({classes, title, onHome, onBack, hide = false}) {
  if (hide) return null;
  return (
    <div className={classes.top}>
      <NavActionsMentora showHome onHome={onHome} onBack={onBack} />
      <div>
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>
      </div>
    </div>
  );
}

function ListBullets({ classes, items }) {
  if (!items || items.length === 0) {
    return <span className={classes.emptyText}>NO REGISTRA</span>;
  }
  return (
    <ul className={classes.listBlock}>
      {items.map((txt, idx) => (
        <li key={`${txt}-${idx}`} className={classes.listItem}>
          <span className={classes.dot} />
          <span className={classes.listText}>{txt}</span>
        </li>
      ))}
    </ul>
  );
}

export function PlaneadorMenuView({ classes, infoAsignatura, items }) {
  const itemsUI = useMemo(() => {
    return (items || []).map((it) => {
      if (it.key === "general") return { ...it, icon: <InfoOutlinedIcon /> };
      if (it.key === "obs") return { ...it, icon: <NotesOutlinedIcon /> };
      return { ...it, icon: <SubjectOutlinedIcon /> };
    });
  }, [items]);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={5}>
        <InfoBasicaAsignaturaCard data={infoAsignatura} />
      </Grid>
      <Grid item xs={12} md={7}>
        <SectionListMentora
          compact
          title="Secciones del planeador"
          hint="Selecciona una sección para gestionarla."
          items={itemsUI}
        />
      </Grid>
    </Grid>
  );
}

export function PlaneadorInfoGeneralView({
  classes,
  cargandoInfoGeneral,
  infoGeneral,
  competenciasGenericas,
  competenciasEspecificas,
  emmaImg,
  TareasTerminadasComponent,
  ciaNivel,
  ciaComponente,
  ciaEstrategia,
  onChangeCiaNivel,
  onChangeCiaComponente,
  onChangeCiaEstrategia,
  onSaveCIA,
  savingCIA = false,
}) {
  const TareasTerminadas = TareasTerminadasComponent;

  if (cargandoInfoGeneral) {
    return (
      <TareasTerminadas
        mensaje="Cargando información general..."
        marginTop="4%"
        imagen={emmaImg}
        widthImg="6%"
        cargando
      />
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={5} style={{ minWidth: 0 }}>
        <Paper className={classes.paneCard} elevation={0}>
          <Typography style={{ fontWeight: 900 }}>Información general</Typography>
          <Divider className={classes.divider} />
          {infoGeneral?.error ? (
            <Typography variant="body2" color="textSecondary">
              {infoGeneral.error}
            </Typography>
          ) : (
            <div className={classes.infoGrid}>
              <div className={classes.label}>Departamento</div>
              <div className={classes.value}>
                {infoGeneral?.departamento_nombre || "NO REGISTRA"}
              </div>
              <div className={classes.label}>Programa</div>
              <div className={classes.value}>
                {infoGeneral?.programa_nombre || "NO REGISTRA"}
              </div>
              <div className={classes.label}>Competencias genéricas</div>
              <div className={classes.value}>
                <ListBullets classes={classes} items={competenciasGenericas} />
              </div>
              <div className={classes.label}>Competencias específicas</div>
              <div className={classes.value}>
                <ListBullets classes={classes} items={competenciasEspecificas} />
              </div>
            </div>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} md={7} style={{ minWidth: 0 }}>
        <Paper className={classes.paneCard} elevation={0}>
          <Typography style={{ fontWeight: 900 }}>
            Componente integrador de aprendizaje (CIA)
          </Typography>
          <Typography className={classes.unitHint} style={{ marginTop: 6 }}>
            Registra el nivel, el componente integrador y la estrategia didáctica.
          </Typography>
          <Divider className={classes.divider} />
          <div className={classes.formGrid}>
            <TextField
              label="Nivel del Componente integrador de aprendizaje"
              variant="outlined"
              size="small"
              value={ciaNivel ?? ""}
              onChange={(e) => onChangeCiaNivel?.(e.target.value)}
              fullWidth
            />
            <TextField
              label="Componente integrador de aprendizaje (CIA)"
              variant="outlined"
              size="small"
              value={ciaComponente ?? ""}
              onChange={(e) => onChangeCiaComponente?.(e.target.value)}
              fullWidth
              multiline
              minRows={3}
            />
            <TextField
              select
              label="Estrategia didáctica"
              variant="outlined"
              size="small"
              value={ciaEstrategia ?? ""}
              onChange={(e) => onChangeCiaEstrategia?.(e.target.value)}
              fullWidth
              helperText="Indique la estrategia didáctica a utilizar en el CIA"
            >
              <MenuItem value="ABP">Aprendizaje basado en problemas (ABP)</MenuItem>
              <MenuItem value="ABPr">Aprendizaje basado en proyectos (ABPr)</MenuItem>
            </TextField>
            <PlaneadorActions
              onSave={onSaveCIA}
              saving={savingCIA}
              saveLabel="Guardar"
            />
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

export function PlaneadorUnidadView({classes, unitKey, unidadState, weekItemsForSelectedUnit}) {
  const unitNumber = String(unitKey || "").replace("u", "") || "?";

  const unitData = unidadState?.[unitKey] || {
    corte: "NO REGISTRA",
    nombreUnidad: "NO REGISTRA",
    resultadoAprendizaje: "NO REGISTRA",
    semanas: {},
  };

  const weekItemsUI = useMemo(() => {
    return (weekItemsForSelectedUnit || []).map((w) => ({
      ...w,
      icon: <SubjectOutlinedIcon />,
    }));
  }, [weekItemsForSelectedUnit]);

  const totalSemanas = weekItemsUI.length;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={5} style={{ minWidth: 0 }}>
        <Paper className={classes.paneCard} elevation={0}>
          <div className={classes.unitMetaRow}>
            <Typography className={classes.unitMetaTitle}>
              Unidad {unitNumber}
            </Typography>
            <Typography className={classes.unitMetaRight}>
              {totalSemanas} semanas
            </Typography>
          </div>
          <Typography style={{ fontWeight: 900 }}>Información de la unidad</Typography>
          <Typography className={classes.unitHint} style={{ marginTop: 6 }}>
            Corte: {unitData?.corte || "NO REGISTRA"}
          </Typography>
          <div className={classes.readBlock}>
            <Typography className={classes.readLabel}>Nombre de la unidad</Typography>
            <div className={classes.readValue}>
              {unitData?.nombreUnidad || "NO REGISTRA"}
            </div>
          </div>
          <div className={classes.readBlock}>
            <Typography className={classes.readLabel}>Resultado de aprendizaje</Typography>
            <div className={classes.readValue}>
              {unitData?.resultadoAprendizaje || "NO REGISTRA"}
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12} md={7} style={{ minWidth: 0 }}>
        <SectionListMentora compact title="Semanas" hint={null} items={weekItemsUI} />
      </Grid>
    </Grid>
  );
}

export function PlaneadorSemanaView({classes, selectedUnitKey, selectedWeekNumber, selectedWeekData, cargandoIndicadores, indicadores, onSelectIndicador, onSaveWeek, onBackToUnit}) {
  const [estrategiasSemana, setEstrategiasSemana] = useState({
    presencial: { realizada: true, esAlternativa: false, descripcionAlternativa: "" },
    independiente: { realizada: true, esAlternativa: false, descripcionAlternativa: "" },
    evaluativa: { realizada: true, esAlternativa: false, descripcionAlternativa: "" },
  });
  useEffect(() => {
    if (!selectedWeekData?.estrategias) return;

    setEstrategiasSemana({
      presencial: {
        realizada: selectedWeekData.estrategias.presencial?.realizada ?? true,
        esAlternativa: selectedWeekData.estrategias.presencial?.es_alternativa ?? false,
        descripcionAlternativa: selectedWeekData.estrategias.presencial?.descripcion_alternativa ?? "",
      },
      independiente: {
        realizada: selectedWeekData.estrategias.independiente?.realizada ?? true,
        esAlternativa: selectedWeekData.estrategias.independiente?.es_alternativa ?? false,
        descripcionAlternativa: selectedWeekData.estrategias.independiente?.descripcion_alternativa ?? "",
      },
      evaluativa: {
        realizada: selectedWeekData.estrategias.evaluativa?.realizada ?? true,
        esAlternativa: selectedWeekData.estrategias.evaluativa?.es_alternativa ?? false,
        descripcionAlternativa: selectedWeekData.estrategias.evaluativa?.descripcion_alternativa ?? "",
      },
    });
  }, [selectedWeekData]);

  if (!selectedUnitKey || !selectedWeekNumber) return null;

  if (cargandoIndicadores) {
    return (<TareasTerminadas mensaje="Cargando indicadores..." imagen={emma_s1} widthImg="7%" cargando />);
  }

  const unitNumber = String(selectedUnitKey).replace("u", "") || "?";

  const indicadorSeleccionado =
    indicadores?.find(
      (i) => i.id === selectedWeekData?.indicador
    ) || null;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Paper className={classes.fullView} elevation={0}>
          <Typography style={{ fontWeight: 900, fontSize: 15 }}>
            Unidad {unitNumber} · Semana {selectedWeekNumber}
          </Typography>
          <Divider style={{ margin: "10px 0" }} />
          <Typography style={{ fontWeight: 700, marginBottom: 6 }}>
            Indicador de desempeño
          </Typography>
          <Autocomplete
            options={indicadores || []}
            value={indicadorSeleccionado}
            getOptionLabel={(option) => option.info}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, newValue) => onSelectIndicador(newValue?.id || null)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                placeholder="Seleccione un indicador"
                fullWidth
              />
            )}
          />
          {indicadorSeleccionado && (
            <Typography variant="caption">
              {indicadorSeleccionado.info}
            </Typography>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} md={8}>
        <EstrategiaReadOnlySemaforo
          titulo="Estrategias presenciales"
          texto={selectedWeekData?.estrategias?.presencial?.nombre || "NO REGISTRA"}
          value={estrategiasSemana.presencial}
          onChange={(v) =>
            setEstrategiasSemana((p) => ({
              ...p,
              presencial: v,
            }))
          }
        />
        <EstrategiaReadOnlySemaforo
          titulo="Estrategias de trabajo independiente"
          texto={selectedWeekData?.estrategias?.independiente?.nombre || "NO REGISTRA"}
          value={estrategiasSemana.independiente}
          onChange={(v) =>
            setEstrategiasSemana((p) => ({
              ...p,
              independiente: v,
            }))
          }
        />
        <EstrategiaReadOnlySemaforo
          titulo="Estrategias evaluativas"
          texto={selectedWeekData?.estrategias?.evaluativa?.nombre || "NO REGISTRA"}
          value={estrategiasSemana.evaluativa}
          onChange={(v) =>
            setEstrategiasSemana((p) => ({
              ...p,
              evaluativa: v,
            }))
          }
        />
        <Box mt={1} display="flex" justifyContent="center">
          <PlaneadorActions
            onSave={async () => {
              const ok = await onSaveWeek({
                selectedUnitKey,
                selectedWeekNumber,
                estrategiasSemana,
              });
              if (ok) onBackToUnit();
            }}
            saveLabel="Guardar"
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export function PlaneadorObservacionesView({classes, value, onChange, onSave, saving = false}) {
  return (
    <div className={classes.fullWrap}>
      <Paper className={classes.fullView} elevation={0}>
        <Typography style={{ fontWeight: 900, fontSize: 15 }}>
          Observaciones
        </Typography>
        <Typography className={classes.unitHint}>
          Registra aquí observaciones generales del desarrollo del curso.
        </Typography>
        <Divider className={classes.divider} />
        <div className={classes.formGrid}>
          <TextField
            label="Observación"
            variant="outlined"
            size="small"
            value={value ?? ""}
            onChange={(e) => onChange?.(e.target.value)}
            fullWidth
            multiline
            minRows={6}
          />
          <PlaneadorActions
            onSave={onSave}
            saving={saving}
            saveLabel="Guardar"
          />
        </div>
      </Paper>
    </div>
  );
}

export function EstrategiaReadOnlySemaforo({titulo, texto, value, onChange}) {
  const setEstado = (estado) => {
    if (estado === "realizada") {
      onChange({ ...value, realizada: true, esAlternativa: false });
    }
    if (estado === "no") {
      onChange({ ...value, realizada: false, esAlternativa: false });
    }
    if (estado === "otra") {
      onChange({ ...value, realizada: true, esAlternativa: true });
    }
  };

  return (
    <Box border={1} borderColor="#e0e0e0" borderRadius={4} padding={1} marginBottom={1}>
      <Typography style={{ fontWeight: 700, marginBottom: 4 }}>
        {titulo}
      </Typography>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={9}>
          <TextField
            value={texto || "NO REGISTRA"}
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={2}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={3}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            height="100%"
            gap={0.5}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <IconButton
                size="small"
                onClick={() => setEstado("realizada")}
                style={{
                  color:
                    value.realizada && !value.esAlternativa
                      ? "#2e7d32"
                      : "#9e9e9e",
                }}
              >
                <CheckCircleIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption">Realizada</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <IconButton
                size="small"
                onClick={() => setEstado("no")}
                style={{
                  color:
                    !value.realizada && !value.esAlternativa
                      ? "#c62828"
                      : "#9e9e9e",
                }}
              >
                <CancelIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption">No se realizó</Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              <IconButton
                size="small"
                onClick={() => setEstado("otra")}
                style={{
                  color: value.esAlternativa ? "#f9a825" : "#9e9e9e",
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption">Otra actividad</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      {value.esAlternativa && (
        <TextField
          label="Describa la actividad realizada"
          variant="outlined"
          size="small"
          fullWidth
          multiline
          minRows={2}
          style={{ marginTop: 6 }}
          value={value.descripcionAlternativa}
          onChange={(e) =>
            onChange({
              ...value,
              descripcionAlternativa: e.target.value,
            })
          }
        />
      )}
    </Box>
  );
}